import {Directive, Renderer,ElementRef,Input,HostListener} from '@angular/core';

@Directive({
  selector: '[table-head-fixer]'
})
export class TableHeadFixerDirective {
  d1 = <any>$(this.el.nativeElement);
  constructor(private el: ElementRef,
              private renderer: Renderer) {
    setTimeout(() => {
      this.check();
    }, 2000);
  }

  check (){
    (this.d1).stickyTableHeaders({
      scrollableArea: $(".item-list")
    });
  }

  @HostListener('window:scroll') onResize() {
  }

}

export const TableHeadFixer_DIRECTIVES = [
  TableHeadFixerDirective
];



// WEBPACK FOOTER //
// /app/src/app/directives/table-head-fixer/table-head-fixer.directive.ts